import { render, staticRenderFns } from "./ReceptionDeliveryGeneralFlagEditor.vue?vue&type=template&id=e2a8c47c&scoped=true&"
import script from "./ReceptionDeliveryGeneralFlagEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDeliveryGeneralFlagEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDeliveryGeneralFlagEditor.vue?vue&type=style&index=0&id=e2a8c47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a8c47c",
  null
  
)

export default component.exports